export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-random/src/defaultSource.js
// module id = 8JDS
// module chunks = 0